import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { fetchClinicUsageMetrics, rangeToWindow } from './api';
import type { TrendRange, UsageMetrics } from './types';

/**
 * Single windowed metrics query. The preset `range` is resolved to a from/to
 * window (the buttons are just date shortcuts); the cards, chart, and per-user
 * table all read from this one result so they stay in sync.
 */
export const useClinicUsageMetrics = (authOrgId: string | null, range: TrendRange) => {
  // Recompute the window only when the range changes (not every render), so the
  // query key is stable and we don't refetch on unrelated re-renders.
  const window = useMemo(() => rangeToWindow(range), [range]);
  return useQuery({
    queryKey: ['clinic-usage', 'metrics', authOrgId, range],
    queryFn: ({ signal }) => fetchClinicUsageMetrics<UsageMetrics>(window, { signal }),
    enabled: !!authOrgId,
  });
};
